(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/oddset-categorized/assets/javascripts/add-tracking-id.js') >= 0) return;  svs.modules.push('/widgets/oddset-categorized/assets/javascripts/add-tracking-id.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isServer = typeof module !== 'undefined' && module.exports;

var addTrackingId = function addTrackingId(object, index) {
  return _objectSpread({}, object, {
    trackingId: "mest-spelade-".concat(object.draw.draw.sport.name.toLowerCase(), "-").concat(index + 1)
  });
};

if (isServer) {
  module.exports = addTrackingId;
} else {
  setGlobal('svs.widget.oddset_categorized.addTrackingId', addTrackingId);
}
 })(window);